import React, { useContext, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useSearchParams } from "react-router-dom"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"
import { CancelUncancelSubscription } from "./CancelUncancelSubscription.jsx"
import { ChangeBillingInterval } from "./ChangeBillingInterval.jsx"
import { SubscriptionItems } from "./SubscriptionItems.jsx"
import { UpdatePaymentMethod } from "./UpdatePaymentMethod.jsx"
import { useSetSelectedStore } from "../../hooks/useFirestoreUserHooks.js"
import { SubscriptionItemSuggestions } from "./SubscriptionItemSuggestions.jsx"

export const BillingSettings = () => {
	const { state, dispatch } = useContext(GlobalStateContext)
	const { t, i18n } = useTranslation()
	const setSelectedStore = useSetSelectedStore()
	const [urlParams] = useSearchParams()
	const updatePayment = urlParams.get("updatepayment")
	const updatePaymentForStore = urlParams.get("updatepaymentforstore")

	const activeSubscription =
		state.kopyBasicSubscription ||
		state.kopyProtectSubscription ||
		state.kopyPlusSubscription ||
		null
	const subscriptionIsSetToBeCancelled =
		activeSubscription?.scheduledChangeAction === "cancel"

	if (!activeSubscription) return ""

	useEffect(async () => {
		if (!activeSubscription?.updatePaymentMethodUrl) return
		if (updatePayment !== "true") return

		if (
			updatePaymentForStore &&
			updatePaymentForStore !== state.shop &&
			state.stores[updatePaymentForStore]
		) {
			await setSelectedStore(state.userId, updatePaymentForStore)
			window.location.reload()
		} else {
			window.location.href = activeSubscription.updatePaymentMethodUrl
		}
	}, [updatePayment, updatePaymentForStore, activeSubscription])

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				padding: "1rem 1rem 1rem 1rem",
				gap: "0.5rem",
			}}
		>
			<div style={{ marginBottom: "0.5rem" }}>
				<h1
					style={{
						fontSize: "1.3rem",
						lineHeight: "1.1rem",
						fontWeight: "600",
					}}
				>
					{t("account.your_subscription")}
				</h1>
				<span
					style={{
						fontSize: "0.8rem",
						fontWeight: "500",
						color: "#777",
					}}
				>
					{t("account.subscription_for")}{" "}
					<span style={{ textDecoration: "underline" }}>
						{state.shop}
					</span>
				</span>
			</div>

			<SubscriptionItems activeSubscription={activeSubscription} />

			<SubscriptionItemSuggestions />

			{!subscriptionIsSetToBeCancelled &&
				activeSubscription.billingInterval &&
				activeSubscription.nextBilledAt && (
					<p
						style={{
							lineHeight: "1.1rem",
							fontSize: "0.9rem",
							color: "#333",
							margin: "1rem 0rem",
						}}
					>
						{t("account.your_subscription_is_renewed")}
						<b>
							{" "}
							{activeSubscription.billingInterval === "yearly"
								? t("account.yearly")
								: activeSubscription.billingInterval ===
									  "quarterly"
									? t("account.quarterly")
									: t("account.monthly")}
						</b>
						. {t("account.your_next_billing_date_is")}
						<b>
							{" "}
							{new Date(
								activeSubscription.nextBilledAt,
							).toLocaleDateString(i18n.language || "en-US", {
								year: "numeric",
								month: "long",
								day: "numeric",
							})}
						</b>
						.
					</p>
				)}

			<CancelUncancelSubscription
				activeSubscription={activeSubscription}
			/>

			{!subscriptionIsSetToBeCancelled && (
				<div style={{ display: "flex", gap: "0.5rem" }}>
					<div style={{ width: "50%" }}>
						<ChangeBillingInterval
							activeSubscription={activeSubscription}
						/>
					</div>
					<div style={{ width: "50%" }}>
						<UpdatePaymentMethod
							activeSubscription={activeSubscription}
						/>
					</div>
				</div>
			)}
		</div>
	)
}
